import type {
  Breadcrumb as BreadcrumbType,
  ProductCollectionPath,
} from '../../../types';

export const formatBreadcrumbs = (
  sliceItems: Array<BreadcrumbType>,
  categoryPaths: Array<ProductCollectionPath>
): Array<BreadcrumbType> => {
  return [
    ...categoryPaths
      .map(({ name, pathName }) => {
        return {
          name,
          pathName,
        };
      })
      .filter(c => !sliceItems.some(si => si.pathName === c.pathName)),
    ...sliceItems,
  ];
};
